import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useFeaturedBook() {
  return useQuery({
    queryKey: ['books', 'featured'],
    queryFn: () => libraryApi.getFeaturedBook(),
    staleTime: 60 * 60 * 1000,
  });
}
